import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { ReportConfigV2 } from 'src/hooks/reportConfigs';
import { ContentId } from 'src/utils/constants/contentId';
import { GridActionType } from 'src/utils/tableUtils';

import * as styles from './ReportsTableContainer.css';
import { ReportsTableV2 } from './ReportsTableV2';

export function ReportsTableContainerV2({
  reports,
  onReportAction,
}: {
  reports?: ReportConfigV2[];
  onReportAction: (
    report: ReportConfigV2,
    actionType: GridActionType,
    event?: React.MouseEvent
  ) => void;
}) {
  const reportsDefault = reports?.filter((r) => r.globalReportTypeId) ?? [];
  const reportsCustom = reports?.filter((r) => !r.globalReportTypeId) ?? [];

  return (
    <div className={styles.mainContent}>
      <div className={styles.reportTableContainer}>
        {reportsDefault.length > 0 && (
          <Stack direction="column">
            <h2
              className={styles.subHeader}
              style={{
                paddingTop: vars.spacing['lg'],
                paddingBottom: vars.spacing['lg'],
              }}
            >
              <Content id={ContentId.DefaultReports} />
            </h2>
            <ReportsTableV2
              reports={reportsDefault}
              onReportAction={onReportAction}
              isGlobalSection
              initState={{
                sorting: [{ id: 'reportName', desc: false }],
              }}
            />
          </Stack>
        )}

        <Stack direction="column">
          <h2
            className={styles.subHeader}
            style={{
              paddingTop: vars.spacing['xl'],
              paddingBottom: vars.spacing['lg'],
            }}
          >
            <Content id={ContentId.CustomReports} />
          </h2>
          <ReportsTableV2
            reports={reportsCustom}
            onReportAction={onReportAction}
            initState={{
              sorting: [{ id: 'reportName', desc: false }],
            }}
          />
        </Stack>
      </div>
    </div>
  );
}
